import { useEffect } from 'react'

import { useCurrentUser } from '@lib/services/user/context'
import { gnarSpec, setGnarUser } from '@lib/tracking/gnar'
import { feMetrics } from '@lib/tracking/metrics/femetrics'
import { ClientMetricsActions, GeneralClientMetrics } from '@lib/tracking/metrics/metrics'

export interface PageShowProps {
  pageId: string
  pageSlug: string
  isPreview?: boolean
  isStaticFallback?: boolean
  isCustom?: boolean
}

export const usePageShow = ({
  pageId,
  pageSlug,
  isPreview = false,
  isStaticFallback = false,
  isCustom = false,
}: PageShowProps) => {
  // const { user } = useCurrentUser()
  // const userJourney = useUserJourneyService()

  useEffect(() => {
    if (!isPreview) {
      void gnarSpec.pageShow({
        pageId,
        pageSlug,
        referrer: document.referrer,
        url: window.location.href,
        isCustomPage: isCustom,
        isStaticFallback,
      })
      // trackGA4PageView(user)
      // trackPerformance(pageId, pageSlug, document.referrer, window.location.href)

      logFeMetricsPageShow(pageSlug)
    }
  }, [pageId, pageSlug, isPreview, isStaticFallback])
  // }, [pageId, pageSlug, isPreview, isStaticFallback, user, userJourney])
}

// TODO: Add allow list for feMetrics page show in the future post launch
// const allowListFeMetricsPageShowPageSlug = new Set(['/', '/plans', '/superhuman-go-intro'])

const logFeMetricsPageShow = (pageSlug: string) => {
  feMetrics
    .getMetric(GeneralClientMetrics.Page)
    .getCounter(ClientMetricsActions.Show)
    .setContext({
      pageSlug,
    })
    .increment()
}

export const useTrackingInit = (_pageId: string, _pageSlug: string) => {
  const { user } = useCurrentUser()
  // const { browserName } = useBrowserService()

  // trackContentInfo(browserName)

  useEffect(() => {
    setGnarUser(user)
  }, [])

  useEffect(() => {
    // If the request fails, user will still be a None user. How should we handle tracking in that case?
    if (!user.isNone) {
      setGnarUser(user)
    }
  }, [user])
}

// export const useBannerShow = (isBannerVisible: boolean, bannerId: string, bannerCtaUrl?: string) => {
//   const { pageId, slug } = useContext(PageContext)
//   const bannerShowEventLogged = useRef(false)

//   useEffect(() => {
//     if (isBannerVisible && !bannerShowEventLogged.current) {
//       gnarSpec.bannerShow(bannerId, pageId, slug, bannerCtaUrl)
//       bannerShowEventLogged.current = true
//     }
//   }, [bannerId, bannerCtaUrl, isBannerVisible, pageId, slug])
// }
